import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';

// COMPONENTS
import RadioCard from '@/components/Form/RadioCard';

// STYLES
import { TitleContainer, Title } from '../styles';

const DVR = props => {
  const {
    t,
    values,
    handleChange,
    handleBlur,
    onRadioCardChange,
    partner_data,
    isRequired,
  } = props;
  const textOverwrites = partner_data?.text_overwrites || {};
  const variants = [
    { text: t('buttons.yes'), value: '1' },
    { text: t('buttons.no'), value: '0' },
  ];

  const handleDvrChange = event => {
    onRadioCardChange(event, handleChange);
  };

  return (
    <>
      <TitleContainer className="form-title">
        <Title
          className={clsx(isRequired && 'required')}
          variant="h4"
          align="center"
          component="h1"
        >
          {textOverwrites.fmb_dvr_title || t('start.dvr.title')}
        </Title>
        <Typography variant="subtitle1" align="center">
          {textOverwrites.fmb_dvr_subtitle || t('start.dvr.subtitle')}
        </Typography>
      </TitleContainer>
      <Grid container spacing={1} justifyContent="center">
        {variants.map(item => (
          <Grid item xs={6} sm={4} md={3} key={item.value}>
            <RadioCard
              name="dvr"
              text={item.text}
              handleChange={handleDvrChange}
              handleBlur={handleBlur}
              value={item.value}
              checkedValue={values.dvr}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

DVR.defaultPros = {
  isRequired: false,
};

DVR.propTypes = {
  t: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  onRadioCardChange: PropTypes.func.isRequired,
  partner_data: PropTypes.object,
  isRequired: PropTypes.bool,
};

export default withTranslation()(React.memo(DVR));
